import { render, staticRenderFns } from "./ColoredNotification.vue?vue&type=template&id=03d53100&scoped=true&"
import script from "./ColoredNotification.vue?vue&type=script&lang=js&"
export * from "./ColoredNotification.vue?vue&type=script&lang=js&"
import style0 from "./ColoredNotification.vue?vue&type=style&index=0&id=03d53100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d53100",
  null
  
)

export default component.exports